import { useTranslation } from "react-i18next";
import { useAppSelector } from "~/lib/store/store";
import { cn } from "~/lib/utils";
import NodataFound from "../shared-components/NoDataFound";
import QuizInfoCard from "./QuizInfoCard";

const UpcomingSyllabus = ({ mode = "desktop" }: { mode: "desktop" | "mobile" }) => {
  const { upcomingQuizData } = useAppSelector((state) => state.satsangQuiz);
  const { t } = useTranslation();
  return (
    <>
      {upcomingQuizData?.length === 0 ? (
        <div className="w-full flex justify-center items-center p-4">
          <NodataFound text={t("satsang_quiz.noUpcomingQuizzes")} />
        </div>
      ) : (
        <div className="w-full flex justify-center items-center">
          <div className={cn("w-full md:w-[30%] grid grid-cols-1 gap-4", mode === "mobile" ? "pb-52" : "")}>
            {upcomingQuizData?.map((quiz, index) => (
              <QuizInfoCard
                id={quiz.id}
                key={index}
                title={quiz.title}
                date={quiz.date}
                time={quiz?.start_time || "19:00"}
                source_type={quiz.source_type}
                source_path={quiz.source_path}
                from="upcoming_quiz"
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default UpcomingSyllabus;
